export default {
  zh: {
    idtitile: 'Distribution - to userID',
    noMore: 'No more records',
    more: 'More',
    distribution: 'Distribution - to userID',
    recharge: 'Recharge - to userID',
    overdraw: 'Overdraw - to userID'
  },
  en: {
    idtitile: 'Distribution - to userID',
    noMore: 'No more records',
    more: 'More',
    empText: 'Oops, no records yet.',
    distribution: 'Distribution - to userID',
    recharge: 'Recharge - to userID',
    overdraw: 'Overdraw - to userID'
  },
  ar: {
    // 阿拉伯
    idtitile: 'التوزيع - إلى أيدي المستخدم',
    noMore: 'لا مزيد من السجلات',
    more: 'أكثر',
    empText: 'عفوًا، لا توجد سجلات حتى الآن.',
    distribution: 'التوزيع - إلى أيدي المستخدم',
    recharge: 'إعادة الشحن - إلى معرف المستخدم',
    overdraw: 'السحب الزائد - إلى معرف المستخدم'
  },
  tr: {
    //土耳其
    idtitile: 'Dağıtım - kullanıcı ID',
    noMore: 'Başka kayıt yok',
    more: 'Daha',
    empText: 'Henüz kayıt yok.',
    distribution: 'Dağıtım - kullanıcı ID',
    recharge: 'Şarj edin - kullanıcı kimliğine',
    overdraw: 'Fazla çekme - kullanıcı kimliğine'
  },
  pt: {
    idtitile: 'Distribuição - para o userID',
    noMore: 'Sem mais registros',
    more: 'Mais',
    empText: 'Ops, ainda sem registros.',
    distribution: 'Distribuição - para o userID',
    recharge: 'Recarga - para o userID',
    overdraw: 'Saque excessivo - para o userID'
  },
  id: {
    idtitile: 'Distribusi - ke userID',
    noMore: 'Tidak ada lagi catatan',
    more: 'Lainnya',
    empText: 'Ups, belum ada catatan.',
    distribution: 'Distribusi - ke userID',
    recharge: 'Isi Ulang - ke userID',
    overdraw: 'Penarikan berlebih - ke userID'
  },
  uz: {
    idtitile: 'Tarqatish - foydalanuvchi IDga',
    noMore: "Yana yozuvlar yo'q",
    more: "Ko'proq",
    empText: "Afsus, hali yozuvlar yo'q.",
    distribution: 'Tarqatish - foydalanuvchi IDga',
    recharge: "To'ldirish - foydalanuvchi IDga",
    overdraw: 'Chekni oshirish - foydalanuvchi IDga'
  },
  ru: {
    idtitile: 'Распределение - на userID',
    noMore: 'Нет больше записей',
    more: 'Больше',
    empText: 'Упс, еще нет записей.',
    distribution: 'Распределение - на userID',
    recharge: 'Пополнение - на userID',
    overdraw: 'Перерасход - на userID'
  },
  fa: {
    idtitile: 'توزیع - به userID',
    noMore: 'هیچ رکوردی بیشتر وجود ندارد',
    more: 'بیشتر',
    empText: 'اوه، هنوز رکوردی وجود ندارد.',
    distribution: 'توزیع - به userID',
    recharge: 'شارژ - به userID',
    overdraw: 'برداشت اضافی - به userID'
  },
  ur: {
    idtitile: 'تقسیم - صارف آئی ڈی کو',
    noMore: 'مزید ریکارڈز نہیں',
    more: 'مزید',
    empText: 'افسوس، ابھی تک کوئی ریکارڈ موجود نہیں۔',
    distribution: 'تقسیم - صارف آئی ڈی کو',
    recharge: 'ریچارج - صارف آئی ڈی کو',
    overdraw: 'اوور ڈرا - صارف آئی ڈی کو'
  }
}



// WEBPACK FOOTER //
// src/pages/app/goldRecold/lang.js